
import React, { Component, PureComponent } from 'react';
import ReactDOM from 'react-dom';
import Icon from '../../buttons/Icon';

class BesoinItem extends PureComponent {
  static defaultProps = {
    icon: '',
    title: '',
  };
  constructor(props) {
    super(props);
    this.state = {
      isSelected: this.props.isChecked,
    };
  }
  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
    this.setState({ isSelected: this.props.isChecked });
  }
  handleOnClick = () => {
    this.props.onClick();
    this.setState({ isSelected: !this.state.isSelected })
    // (this.state.isSelected ? this.setState({ isSelected: false }) : this.setState({ isSelected: true }))
  }
  render() {
    const { isChecked, id, title, icon } = this.props;
    const classes = (this.state.isSelected ? ' selected' : '');

    return (
      <li className={"service-item" + classes}
        tabIndex='0'
        onKeyDown={(e) => e.key === 'Enter' && this.handleOnClick()}
        onClick={this.handleOnClick}
      >
        <div className="service-item__wrapper" >
          <div className="service-item__icon">
            <Icon className={classes} dataImage={`${icon}`} />
          </div>
          <div className="service-item__title">
            {title}
          </div>
        </div>
      </li>
    );
  }
}
export default BesoinItem;
